export default "__VITE_ASSET__DbggI3Vt__"